module.exports = __webpack_public_path__ + "assets/group-20@3x.ed62aab8fba6bb9f91910e88cb25d06d.png";